//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { ITagDTO } from '../../../DTO/ITagDTO';

//element.Name=TagController result.Name=TagController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.TagController);
/** WebApiController: TagController */
export class TagController extends DefaultDtoControllerProxy<ITagDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'Tags', BusinessObjectType.Tag);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<ITagDTO>
	{
		return (this.axios.get('Tags/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
